<template>
	<div id="infobar">
		<div class="jge">
		    <ul>
		        <li class="jge1">
		            <span>
		                资讯专区
		            </span>
		            <ul>
		                <li v-for="(item,index) in info[0]" :key="index">
		                    <img src="~assets/images/xinwen.gif" alt="">
		                    <a :href="'http://itbx.cc/home/热门资讯/'+item.title">{{item.title}}</a>
		                </li>    
		            </ul>
		        </li>
		       <li class="jge1">
		            <span>
		                教程专区
		            </span>
		            <ul>
		                <li v-for="(item,index) in info[1]" :key="index">
		                    <img src="~assets/images/xinwen2.gif" alt="">
		                    <a :href="'http://itbx.cc/home/教程专区/'+item.title">{{item.title}}</a>
		                </li> 
		            </ul>
		        </li>
		       <li class="jge2">
								<span>
												百度热搜
								</span>
								<ul>
										<li v-for="(item,index) in info[2]" :key="index">
												<img src="~assets/images/xinwen3.gif" alt="">
												<a :href="item.url">{{item.title}}</a>
										</li> 
								</ul>
		        </li>
		    </ul>
		</div>
	</div>
</template>

<script>
	export default{
		name:'infobar',
		props:{
			info:{
				type:Array,
				default(){
					return [{'zx':'暂无数据'},{'jc':'暂无数据'},{'rs':'暂无数据'}]
				}
			}
		},
		data(){
			return{
				
			}
		},
		methods:{
		}
	}
</script>

<style scoped>
	.jge{
	    height:300px;
	    /* border: solid 2px #000000; */
	    margin-top: 15px;
	}
	.jge1{
	    float: left;
	    width: 370px;
	    /* border: solid 2px #000000; */
	    margin-right: 30px;
	    height: 300px;
	}
	.jge2{
	    float: right;
	    width: 370px;
	    /* border: solid 2px #000000; */
	    height: 300px;
	}
	.jge1 span{
	    margin-left: 5px;
	    color: rgb(59, 59, 59);
	    font-size: 20px;
	    font-weight: bold;
	}
	.jge1 ul li{
	    margin-top: 20px;
	}
	.jge1 ul li img{
	    float: left;
	    margin-left: 10px;
	    margin-right: 10px
	}
	
	.jge2 span{
	    margin-left: 5px;
	    color: rgb(59, 59, 59);
	    font-size: 20px;
	    font-weight: bold;
	}
	.jge2 ul li{
	    margin-top: 20px;
	}
	.jge2 ul li img{
	    float: left;
	    margin-left: 10px;
	    margin-right: 10px;
	    margin-top: 5px;
	}
	.jge1 ul li a:link{
	    color: rgb(114, 114, 114);
	    text-decoration: none;
	}
	.jge1 ul li a:visited{
	    color: rgb(114, 114, 114);
	}
	.jge1 ul li a:hover{
	    color: rgb(240, 88, 88);
	}
	.jge2 ul li a:link{
	    color: rgb(114, 114, 114);
	    text-decoration: none;
	}
	.jge2 ul li a:visited{
	    color: rgb(114, 114, 114);
	}
	.jge2 ul li a:hover{
	    color: rgb(240, 88, 88);
	}
</style>